import { Pipe, PipeTransform } from '@angular/core';
import { LabelService } from "libraries/service/label/label.service";

/**
 * Pipes that encapsulates labelService.completeLabel(...) for direct usage in templates.
 *
 * Example :<br />
 * `{{wording.myLabelToComplete | completeLabel: aDynamicValue}}`
 */
@Pipe({
    name: 'completeLabel'
})
export class CompleteLabelPipe implements PipeTransform {

    constructor(private readonly labelService: LabelService) {
    }

    public transform(stringToComplete: string, replacements: string | { [p: string]: string | number }): string {
        return this.labelService.completeLabel(stringToComplete, replacements);
    }

}
